import styled from "styled-components";
import Colors from "../../../shared/colors";

export default styled.div`
  .wrapper {
    background: ${Colors.alabaster};
    padding: 140px 0px 100px 0px;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    overflow-y: auto;
  }

  .layout {
    max-width: 1100px;
    margin: 0 auto;

    .text {
      width: 1321px;
      margin-left: -121px;
    }

    .container {
      @media (min-width: 1400px) {
        max-width: 1321px;
      }
    }

    @media screen and (max-width: 1200px) {
      max-width: 800px;
    }

    @media screen and (max-width: 850px) {
      max-width: 600px;
    }
  }

  .h1 {
    margin-bottom: 20px;
  }

  .cardsContainer {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }

  .text {
    font-size: 16px;
    line-height: 19px;
    color: ${Colors.doveGray};
    text-align: justify;

    a {
      font-size: 16px;
      line-height: 19px;
      color: ${Colors.doveGray};
    }

    a:hover {
      color: ${Colors.gray};
      cursor: pointer;
    }
    span {
      margin-right: 5px;
    }
  }

  .container {
    padding-top: 55px;
  }

  .displayflex {
    display: flex;
    justify-content: center;
    gap: 1rem;
    flex-wrap: wrap;
  }

  .wrapper-buttons {
    justify-content: space-evenly;

    span {
      font-size: 16px;
      line-height: 19px;
      color: ${Colors.doveGray};
      text-decoration: underline;
    }

    span:hover {
      color: ${Colors.gray};
      cursor: pointer;
    }
  }
`;
